export const ALL_SP_CATEGORIES = 'allSPCategories';
export const ALL_SP_MODELS = 'allSPModels';
export const ALL_SP_SERIES = 'allSPSeries';
export const ALL_SP_LINES = 'allSPLines';
export const MIN_CARDS_FOR_SORT_OPTION = 3;
